import { Box, Container, Heading, Link, Text } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';

import { CalculatorFormLayout } from '../CalculatorFormLayout';
import { useGlobalContext } from '../../../core/contexts/GlobalContext';

export const DashboardCalculatorLayout = () => {
    const [t, { language: lang }] = useTranslation();
    const { dashboardRole } = useGlobalContext();

    return (
        <DashboardContainer>
            <DashboardCard>
                <Box mb={10}>
                    <Heading color="panel.850" size="md" fontWeight="500" lineHeight={8} pb={2}>
                        {t('dashboard.calculator.title')}
                    </Heading>
                    <Text lineHeight={6} color="panel.550">
                        {dashboardRole === 'contractor' ? (
                            <Trans
                                i18nKey="dashboard.calculator.contractor-subtitle"
                                components={{
                                    Link: <Link href={`/${lang}/fast/`} fontWeight="normal" />,
                                }}
                            />
                        ) : (
                            <Trans i18nKey="dashboard.calculator.employer-subtitle" />
                        )}
                    </Text>
                </Box>
                <CalculatorFormLayout />
            </DashboardCard>
        </DashboardContainer>
    );
};

export const DashboardContainer = styled(Container)`
    max-width: var(--ck-sizes-container-lg);
    padding-inline-start: var(--ck-sizes-8);
    padding-inline-end: var(--ck-sizes-8);
`;

export const DashboardCard = styled(Box)`
    background: var(--ck-colors-panel-50);
    padding: var(--ck-space-6);
    border-radius: var(--ck-radii-lg);
    border: 1px solid rgba(221, 223, 229, 0.4);
`;
